import { Subject } from 'rxjs/Subject';
import { Observable } from 'rxjs/Observable';

export class TransitionBarService {
  private _active = new Subject<boolean>();

  constructor() {
  }

  getState(): Observable<boolean> {
    return this._active.asObservable();
  }

  barActive( val: boolean ) {
    this._active.next(val);
  }
}



// WEBPACK FOOTER //
// ./app/ui/transition-bar/transition-bar.service.ts